(() => {
  'use strict';

  const isAbraActive = () => document.body.classList.contains('abra--activated') || 
                             document.body.classList.contains('abra--applied');

  let busy = false, timer = null;

  const forceVisible = (el) => {
    if (!el) return;
    el.style.removeProperty('visibility');
    el.style.removeProperty('display');
    el.style.removeProperty('opacity');
    if (getComputedStyle(el).visibility === 'hidden') {
      el.style.setProperty('visibility', 'visible', 'important');
    }
  };

  const update = (n) => {
    const icon = document.querySelector('cart-icon');
    if (!icon) return;

    const bubble = icon.querySelector('[ref="cartBubble"]');
    const count = icon.querySelector('[ref="cartBubbleCount"]');
    const sr = icon.querySelector('[ref="cartBubbleText"] .visually-hidden');

    if (count) {
      count.textContent = n < 100 ? n : '';
      count.classList.toggle('hidden', !n);
    }
    if (sr) sr.textContent = `Total items in cart: ${n}`;
    if (bubble) bubble.classList.toggle('visually-hidden', !n);
    icon.classList.toggle('header-actions__cart-icon--has-cart', n > 0);

    forceVisible(icon);
    forceVisible(document.querySelector('cart-drawer-component > button'));

    let p = icon.parentElement;
    while (p && p !== document.body) {
      forceVisible(p);
      p = p.parentElement;
    }

    sessionStorage.setItem('cart-count', JSON.stringify({ value: String(n), timestamp: Date.now() }));
  };

  const process = async () => {
    if (busy) return;
    busy = true;
    try {
      const { item_count: n = 0 } = await (await fetch('/cart.js')).json();
      if (typeof window.opusRefreshCart === 'function') await window.opusRefreshCart();
      update(n);
      setTimeout(() => update(n), 100);
      setTimeout(() => update(n), 300);
    } catch (e) {}
    setTimeout(() => { busy = false; }, 500);
  };

  const handle = () => {
    if (busy || !isAbraActive()) return;
    clearTimeout(timer);
    timer = setTimeout(process, 300);
  };

  const init = () => {
    window.addEventListener('OpusCartChange', handle);
    window.addEventListener('abra:cart:changed', handle);
  };

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();

(() => {
  const MODAL = '.quick-add-modal';

  const getVariantId = (modal) => {
    const checked = modal.querySelector('variant-picker input[type="radio"][data-variant-id]:checked');
    if (checked) return checked.dataset.variantId;
    return modal.querySelector('input[name="id"][ref="variantId"], input[name="id"]')?.value || null;
  };

  const sync = (modal) => {
    if (!modal) return;
    const id = getVariantId(modal);
    if (!id) return;
    modal.querySelectorAll('product-price, product-price [ref="priceContainer"]')
      .forEach((el) => el.setAttribute('data-variant-id', id));
  };

  const triggerAbra = () => {
    try { window.Abra?.render?.(); } catch (err) { console.warn('[Abra.render]', err); }
  };

  const syncAndRender = (modal) => {
    sync(modal);
    triggerAbra();
  };

  const getModal = () => document.querySelector(MODAL);

  document.addEventListener('variant:update', (e) => {
    const modal = e.target.closest?.(MODAL) || getModal();
    requestAnimationFrame(() => syncAndRender(modal));
  });

  document.addEventListener('change', (e) => {
    const el = e.target;
    if (el?.tagName === 'INPUT' && el.type === 'radio' && el.dataset.variantId) {
      const modal = el.closest(MODAL);
      if (modal) requestAnimationFrame(() => syncAndRender(modal));
    }
  });

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest?.('quick-add-component, [data-quick-add], .quick-add__button');
    if (!trigger) return;
    const tick = (tries = 20) => {
      const modal = getModal();
      if (modal?.hasAttribute('open') && modal.querySelector('product-price')) {
        sync(modal);
      } else if (tries > 0) {
        requestAnimationFrame(() => tick(tries - 1));
      }
    };
    tick();
  });

  sync(getModal());
})();